import {
  Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import Course from '../../course.class';
import { VerificationComponent } from 'src/app/components/verification/verification.component';
import { validateCourseGeneralInfo, WEB_URL_MAX_LENGTH } from 'src/app/utils/course-validation.utils';

@Component({
  selector: 'app-general-info',
  templateUrl: './general-info.component.html',
  styleUrls: [ './general-info.component.scss' ],
})
export class GeneralInfoComponent implements OnInit, OnChanges {
  @Output() stepForward = new EventEmitter<boolean>();
  @Output() stepBack = new EventEmitter<any>();
  @Output() closeDialogEmitter = new EventEmitter<any>();
  @Output() validationChange = new EventEmitter<{ isValid: boolean }>();
  @Input() courseTypes: any;
  @Input() course: Course;
  @Input() isEditMode: any;
  @Input() isDuplicateCourse: any;
  @Input() isCourseRequestApproval: any;

  constructor(public dialog: MatDialog) {
  }

  ngOnInit(): void {
    // Emit initial validation status when component loads
    if (this.course) {
      this.emitValidationStatus();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['course'] || changes['courseTypes']) {
      this.emitValidationStatus();
    }
  }

  updateCourseParameter = (
    event: any, parameter: keyof Course, type?: string,
  ) => {
    if (parameter === 'courseDescription') {
      this.course.setProperty(parameter, event);
    } else if (parameter === 'courseType') {
      const inputValue = event?.target?.value;
      const selectedType = this.courseTypes?.find((courseType: any) => courseType.courseType === inputValue);
      
      // If no match found, set courseType to undefined to trigger validation error
      if (selectedType) {
      this.course.setProperty('courseType', selectedType);
      this.course.setProperty('courseTypeId', selectedType?.id);
      } else {
        // Clear courseType if input doesn't match any valid type
        this.course.setProperty('courseType', undefined);
        this.course.setProperty('courseTypeId', undefined);
      }
    } else if (parameter === 'courseSize') {
      const sizeValue = event?.target?.value;
      this.course.setProperty(parameter, sizeValue ? Number(sizeValue) : undefined);
    } else {
      this.course.setProperty(parameter, event?.target?.value);
    }
    
    // Emit validation status after update
    this.emitValidationStatus();
  }

  makePositive = () => {
    // this.course.creditHours = Math.abs(this.course.creditHours)
  }

  updateCourse = () => {
    const validation = validateCourseGeneralInfo(this.course);
    if (!validation.isValid) {
      return;
    }
    this.stepForward.emit(true);
  }

  checkDisabled = (): boolean => {
    const validation = validateCourseGeneralInfo(this.course);
    return !validation.isValid;
  }

  get webUrlError(): string | null {
    const val = this.course?.hyperlink;
    if (val && typeof val === 'string' && val.trim().length > WEB_URL_MAX_LENGTH) {
      return `Web URL must be ${WEB_URL_MAX_LENGTH} characters or less`;
    }
    return null;
  }

  private emitValidationStatus(): void {
    const validation = validateCourseGeneralInfo(this.course);
    this.validationChange.emit({ isValid: validation.isValid });
  }

  confirmInactive = (e: Event) => {
    const target = e.target as HTMLInputElement;
    const isChecked = target.checked;

    if (!isChecked && this.isEditMode) {
      const confirmDialogRef = this.dialog.open(VerificationComponent, {
        data: {
          type: 'alert',
          title: 'Are you sure you want to set this session to Inactive?',
          text: 'Users will be unregistered and the session will be removed and will not return upon course reactivation. This action CANNOT BE UNDONE. If you are trying to HIDE the course from the catalog, please adjust or remove the Course Availability instead.',
          confirmButtonTitle: 'Yes, cancel registrations and set course to inactive',
          cancelButtonTitle: 'No, keep it active',
          confirmButtonClass: 'red',
        },
      })

      confirmDialogRef.afterClosed().subscribe((result) => {
        if (result === 'verified') {
          this.course.setProperty('courseActiveFlag', false);
        } else {
          this.course.setProperty('courseActiveFlag', true);
          target.checked = true;
        }
      });
    }


  }

  closeDialog = () => {
    this.closeDialogEmitter.emit();
  }

}
